import { breakpoints } from '@commons/contexts/responsive';

import { type Hit } from '../Hit';
import ResultDefault from './Default';

/**
 * Next.js Image `sizes` property for the search results.
 *
 * @see https://nextjs.org/docs/app/api-reference/components/image#sizes
 */

export const RESULT_IMAGE_SIZES = `(max-width: ${breakpoints.md}px) 100vw, (max-width: ${breakpoints.lg}) 480px, 620px`;

/**
 * ResultFactory component for the Algolia search block.
 *
 * Renders the appropriate component based on the hit type.
 */

const ResultFactory = ({ hit }: { hit: Hit }) => {
  switch (hit.type) {
    default:
      return <ResultDefault hit={hit} />;
  }
};

export default ResultFactory;
